// extracted by mini-css-extract-plugin
export default {"lauchApp":"lauchAppBtn_lauchApp__w0sC3","lauchApp__icon":"lauchAppBtn_lauchApp__icon__Jb3OB","lauchApp__text":"lauchAppBtn_lauchApp__text__uJhxG"};